import React from 'react'
import PropTypes from 'prop-types'

import { CLICK_THROUGH_LINK } from '../../../../fields'

import useStyles from '../../../../styles'

const LinkSectionPreview = ({ data }) => {
  const classes = useStyles()

  const link = data[CLICK_THROUGH_LINK][0]

  if (!link) {
    return null
  }

  return <p className={classes.linkPreview}>{link}</p>
}

LinkSectionPreview.propTypes = {
  data: PropTypes.object
}

export default LinkSectionPreview
